import React from 'react'

type DraftMessageIconProps = {
  width?: number | string
  height?: number | string
  className?: string
  color?: string
}

export const DraftMessageIcon = ({
  width = 20,
  height = 20,
  className,
  color = 'currentColor',
}: DraftMessageIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M13.3333 2.5L17.5 6.66667L6.66667 17.5H2.5V13.3333L13.3333 2.5Z"
      stroke={color}
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
